/**
 * @version: v 1.0.0
 * @Author: zengying
 * @Date: 2022/9/28 10:23
 * @FileName: about.js
 * @LastEditor: 2022/9/28 10:23
 * @Name: OurAdvantages
 */


const ourAdvantages = {
  routes: [
    {
      path: '/ourAdvantages',
      name: 'ourAdvantages',
      meta: {
        title: '树'
      },
      component: () => import('@/project/views/our-advantages/our-advantages.vue')
    }
  ]
};
export default ourAdvantages;




// WEBPACK FOOTER //
// ./src/project/router/OurAdvantages.js